import { useContext, useEffect } from "react";
import { useLocation } from "react-router";
import { resolveRouteBackground } from "../../common/backgrounds";
import { DataContext } from "../../context/dataProvider";
import { useStyles } from "../../context/stylesContext";

/**
 * Синхронизирует глобальный фон с текущим маршрутом.
 * Должен рендериться внутри Router (например, в RootLayout).
 *
 * Раньше каждая страница ставила фон в своём useEffect — при возврате
 * на главную зависимости не менялись и картинка не обновлялась.
 */
function BackgroundSync() {
  const { pathname } = useLocation();
  const context = useContext(DataContext);
  const { setStyles } = useStyles();

  const userServer = context?.user?.userServer ?? null;

  useEffect(() => {
    setStyles(resolveRouteBackground(pathname, userServer));
  }, [pathname, userServer, setStyles]);

  return null;
}

export default BackgroundSync;
